import { fromJS, List, Map } from "immutable"
import actionTypes from "../../actions/actionTypes"
import requestStatus from "../../constants/requestStatus"

const INIT_STATE  = Map({
    status: requestStatus.INITIALIZED,
    error: null,
    data: Map({
        items: Map(),
        order: List()
    })
})

const onRequest = state             => state.set('status', requestStatus.REQUEST_PENDING)
                                            .set('error', Map())

const onError   = (state, action)   => state.set('status', requestStatus.REQUEST_ERROR)
                                            .setIn(['error','events'], action.payload.errorMessage)

const onSuccess = (state, action)   => state.set('status', requestStatus.REQUEST_SUCCESS)
                                            .deleteIn(['error', 'events'])
                                            .setIn(['data', 'order'], fromJS(action.payload.data.events.order))
                                            .setIn(['data', 'items'], fromJS(action.payload.data.events.items))

const onMail = (state, action)    => state.set('status', requestStatus.REQUEST_SUCCESS)
                                            .deleteIn(['error', 'events'])
                                    
const onUpdate = (state, action)    => state.set('status', requestStatus.REQUEST_SUCCESS)
                                            .deleteIn(['error', 'events'])
                                            .setIn(['data', 'items', String(action.payload.data.id)], fromJS(action.payload.data))


const eventsReducer =(state = INIT_STATE, action) => {
    switch(action.type) {
        case actionTypes.EVENTS_ALL_REQUEST:
        case actionTypes.EVENTS_EVENTS_UPDATE_REQUEST:
        case actionTypes.EVENTS_EVENTS_DELETE_REQUEST:
        case actionTypes.EVENTS_EVENTS_SEND_MAIL_REQUEST:
            return onRequest(state, action);
        case actionTypes.EVENTS_ALL_SUCCESS:
        case actionTypes.EVENTS_EVENTS_DELETE_SUCCESS:
            return onSuccess(state, action);
        case actionTypes.EVENTS_ALL_ERROR:
        case actionTypes.EVENTS_EVENTS_UPDATE_ERROR:
        case actionTypes.EVENTS_EVENTS_DELETE_ERROR:
        case actionTypes.EVENTS_EVENTS_SEND_MAIL_ERROR:
            return onError(state, action);
        case actionTypes.EVENTS_EVENTS_UPDATE_SUCCESS:
            return onUpdate(state, action)
        case actionTypes.EVENTS_EVENTS_SEND_MAIL_SUCCESS:            
            return onMail(state, action)
        default:
            return state;
    }
}

export default eventsReducer